import React, { Component } from 'react';
import classes from './Table.css';
import Button from '../../../components/UI/Button/Button';

class Table extends Component {
    onSort = (sort) => {
        this.props.onSort(sort)
    }
    render() {
        let header = [];
        let rows = [];
        let i = 0;
        header = [];
            for (let k in this.props.header) {
                let h = this.props.header[k];

                i = i + 1;
                let c = classes.cell;

                if (h.full) {
                    c = [classes.cell, classes.full].join(' ');
                }
                if (h.sort && h.sort !== '') {
                    header.push(
                        <div onClick={(event) => this.onSort(h.sort)}  style={h.style} className={c}>{h.name}</div>
                    )
                }
                else {
                    header.push(
                        <div  style={h.style} className={c}>{h.name}</div>
                    )
                }
            }
        


        rows = [];
        let k = 0;
        for (let k in this.props.data) {
            let r = this.props.data[k];
            let i = 0;
            let highlight = false;
            var rw = [];
            k = k + 1;
            let rkey = 'r' + k;
            for (let k in r.data) {
                let d = r.data[k];

                let c = classes.cell;
                i = i + 1;
                let key = 'h' + i;

                if (d.full) {
                    c = [classes.cell, classes.full].join(' ');

                }
                if (d.type == 'button') {
                    rw.push(
                    <div key={key} className={c} style={d.style}> <Button
                        btnType="Success"
                        clicked={(event) => this.props.onClick(event, d.oid)}>{d.label}</Button>
                    </div>
                    );
                }
                else if (d.link && d.link !== "") {
                    rw.push(<div key={key} className={c} style={d.style}><a href={d.link} target={d.target}>{d.value}</a></div>);
                }

                else {
                    rw.push(<div key={key} className={c} style={d.style}>{d.value}</div>)
                }
            }
            if (r.highlight) {
                rows.push(<div key={rkey} oid={r.oid} className={classes.rowhighlight} onClick={this.props.editPopupHandler}>{rw}</div>);
            }
            else {
                rows.push(<div key={rkey}  oid={r.oid} className={classes.row} onClick={this.props.editPopupHandler}>{rw}</div>);
            }
        }
        return (
            <div className={classes.maxarea}>
                <div className={classes.fulltable}>
                    <div className={classes.wraptable}>
                        <div className={classes.table}>
                            <div className={classes.row + ' ' + classes.header}>
                                {header}
                            </div>
                            {rows}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default (Table);


// WEBPACK FOOTER //
// ./src/components/UI/Table/Table.js